import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { BaseSiteConfigService } from '../base-site/base-site-config.service';

@Injectable({
  providedIn: 'root',
})
export class PlpPopupService {
  constructor(private baseSiteConfigService: BaseSiteConfigService) {}

  getPlpPopupEnabledConfig$(): Observable<any> {
    return this.baseSiteConfigService
      .getBaseSiteConfigValues$(['shimano.plp.popup.enabled'])
      .pipe(map((configs) => configs && configs.map((res: any) => res.value === 'true')[0]));
  }

  getPdpAllVvcEnabledConfigs$(): Observable<any> {
    return this.baseSiteConfigService
      .getBaseSiteConfigValues$(['shimano.pdp.all.vvc.enabled'])
      .pipe(map((configs) => configs && configs.map((res: any) => res.value === 'true')[0]));
  }
}
